import {fromEvent, merge, Observable} from 'rxjs';
import {map, share}                   from 'rxjs/operators';

import IPlayerStores             from '../../../State/Shared/Interfaces/IPlayerStores';
import MediaEventType            from '../Constants/MediaEventType';
import SyntheticMediaEventType   from '../Constants/SyntheticMediaEventType';
import IMediaEventsStreamPayload from '../Interfaces/IMediaEventsStreamPayload';
import ISolution                 from '../Interfaces/ISolution';

import createTimeUpdateStream from './createTimeUpdateStream';

const createObservableFromMediaEvent = (
    videoElement: HTMLVideoElement,
    eventType: MediaEventType
): Observable<MediaEventType> =>
    fromEvent(videoElement, eventType)
        .pipe(
            map((event: Event) => event.type as MediaEventType)
        );

/**
 * @param stores All player stores
 * @param solution The attached solution
 * @param customMediaEvent$ An injected observable allowing the solution to emit arbitrary media events at runtime.
 */

const createMediaEventsStream = (
    stores: IPlayerStores,
    solution: ISolution,
    customMediaEvents$?: Observable<SyntheticMediaEventType>
): Observable<IMediaEventsStreamPayload> => {
    const events = [
        createObservableFromMediaEvent(solution.videoElement, MediaEventType.ENDED),
        createObservableFromMediaEvent(solution.videoElement, MediaEventType.LOADED_META_DATA),
        createObservableFromMediaEvent(solution.videoElement, MediaEventType.PAUSE),
        createObservableFromMediaEvent(solution.videoElement, MediaEventType.PLAY),
        createObservableFromMediaEvent(solution.videoElement, MediaEventType.VOLUME_CHANGE),
        createTimeUpdateStream(stores.playback.update$)
    ];

    if (customMediaEvents$ instanceof Observable) {
        events.push(customMediaEvents$);
    }

    return merge(...events)
        .pipe(
            map((eventType: MediaEventType) => ({
                state: solution.state,
                type: eventType
            })),
            share()
        );
};

export default createMediaEventsStream;